import { connect } from 'react-redux';
import ForgotPassword from './ForgotPassword';
import { forgotPasswordRequest, resetErrorMesage } from '../../../store/actions/auth.actions';

const mapDispatchToProps = { forgotPasswordRequest, resetErrorMesage };

const mapStateToProps = () => { };

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);